import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from "react-html-parser";
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Travolta from '../../img/Travolta.gif'

import './notFoundComponent.scss'

class NotFoundComponent extends React.Component {
    render() {
        return (
            <Container className={"not-found-wrapper"}>
                <div className={"not-found"}>
                    <span className={"not-found-404"}>404</span>
                    <br />
                    {this.props.match.params.id ?
                        <span>{this.props.translate(this.props.match.params.id)}</span> :
                        <span className={"not-found-text"}>{ReactHtmlParser(this.props.translate("UnhappyUser.NotFound"))}</span>
                    }
                    <Link to='/' className={"not-found-button-back"}>
                        <button className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}>
                            {this.props.translate('Common.Back.Home')}
                        </button>
                    </Link>
                </div>
            </Container>
        )
    }
}

export default withRouter(withLocalize(NotFoundComponent));
